import React from 'react'
import {
  Grid,
  Box,
  Button
} from "@material-ui/core"
import { ideaEditStyles } from './IdeaEditStyles'
import Info from '@material-ui/icons/Info';
import dialogVideoSvg from '../../assets/imgs/dialog-video.svg';
import { EditUpload, EditUploadButton } from './../../components/Upload';
import AddCircleOutlinedIcon from '@material-ui/icons/AddCircleOutlined';
import VideocamIcon from '@material-ui/icons/Videocam';

export const IdeaEditGeneralVideo = () => {
  const classes = ideaEditStyles();

  return (
    <Grid item xs={12}>
      <Grid container spacing={3} className={classes.root}>
        <Grid item xs={12} className={classes.header}>
          <Box display='flex' alignItems='center'>
            <Box className={classes.iconHeader}>
              <VideocamIcon color="primary" />
            </Box>
            <Box className={classes.titleCard}>vídeos</Box>
          </Box>
          <EditUploadButton 
            type="video"
            variant="text"
            text={"adicionar vídeo"}
            icon={<AddCircleOutlinedIcon />}
          />
        </Grid>
        <Grid item xs={12}>
        <EditUpload
            type="video"
            img={dialogVideoSvg}
            name="video"
            accept="video/*"
            message=""
            maxSize={52428800}
          />
          <Box className={classes.info}>
            <Info style={{fontSize: 15, marginRight: 7 }}/>
            <p>O arquivo deve possuir tamanho máximo de<strong> 50mb</strong>.</p>
          </Box>
        </Grid>
      </Grid>
    </Grid>
  )
}
